import _inheritsLoose from '@babel/runtime/helpers/inheritsLoose';
import ExtendableError from 'es6-error';

const SubmissionError =
  /*#__PURE__*/
  (function (_ExtendableError) {
    _inheritsLoose(SubmissionError, _ExtendableError);

    function SubmissionError(errors) {
      const _this =
        _ExtendableError.call(this, 'Submit Validation Failed') || this;
      _this.errors = errors;
      return _this;
    }

    return SubmissionError;
  })(ExtendableError);

export default SubmissionError;
